<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" data-dismiss="modal" aria-label="Cancel" class="modal-close" @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <div v-if="!showConfirmationScreen">
                        <h2 class="mb-5">Are you sure you want to remove <strong>{{serviceSelectedName}}</strong>
                        from your favourite markets?</h2>
                        <button class="btn btn-danger mr-2" @click="closeModal()" data-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary" @click="confirmRemovingFavourite()">Confirm</button>
                    </div>
                    <div v-else>
                        <h1 class="heading-large mt-0">{{confirmationMessage}}</h1>
                        <i class="fas d-block fa-5x my-4" :class="removeSuccessful? 'fa-check-circle text-primary' : ['fa-times-circle', 'text-tertiary']"></i>
                        <button class="btn btn-tertiary" @click="closeModal()" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            showConfirmationScreen: false,
            removeSuccessful: false,
            confirmationMessage: ''
        }
    },
    computed: {
        ...mapState('login', ['userLoggedIn']),
        ...mapState('selectFavourites', ['marketFavouritesList', 'favouriteOptionSelected', 'serviceSelectedName'])
    },
    methods: {
        ...mapActions('selectFavourites', ['updateShowConfirmationRemoveFavourite', 'updateFavouritesMarkets', 
            'selectFavouriteOption', 'updateNoFavouriteRemaining']),
        closeModal: function(){
            $(this.$el).modal('hide')
            this.updateShowConfirmationRemoveFavourite(false)
        },
        confirmRemovingFavourite: async function(){
            const userId = this.userLoggedIn.userId
            const key = 'FAVOURITE_MARKETS'

            let favouriteMarkets = Object.assign([], this.marketFavouritesList)
            favouriteMarkets.splice(this.favouriteOptionSelected, 1)
            
            const payload = {
                favouriteMarkets: favouriteMarkets,
                userId: userId,
                key: key
            }

            const response = await this.axios.post('/api/removeFavouriteMarket', payload)
            
            /* If removing was successful, fetch the updated favourites list */
            if (response.data.success) {
                const serviceToRemove = this.serviceSelectedName

                const fetchResponse = await this.axios.get('/api/getFavourites', {params: {
                        userId: userId, 
                        key: key
                    }})
                
                /* If fetching the updated list was successful, update the store and then we need to select another tab */
                if (fetchResponse.data.success){
                    this.updateFavouritesMarkets(fetchResponse.data.payload.favouriteMarkets)

                    /* If this is the first tab, then select the next tab, otherwise select the tab before this one */
                    const newActiveIndex = this.favouriteOptionSelected == 0 ? 0 : this.favouriteOptionSelected - 1
                    const serviceName = this.favouriteOptionSelected == 0 ? //If the first tab is removed, check whether there is still any favourite
                        (this.marketFavouritesList.length > 0? this.marketFavouritesList[0].type : '') : this.marketFavouritesList[newActiveIndex].type

                    const newSelectionPayload = {
                        key: newActiveIndex,
                        serviceName: serviceName
                    }
                    this.selectFavouriteOption(newSelectionPayload)

                    /* If that was the last favourite market on the list, then indicate that user has not set up any */
                    if (this.marketFavouritesList.length < 1){
                        this.updateNoFavouriteRemaining()
                    }
                }

                this.removeSuccessful = true
                this.confirmationMessage = serviceToRemove + ' has been successfully removed from your favourites'
            }
            else {
                this.removeSuccessful = false
                this.confirmationMessage = 'Sorry, we are unable to remove this market at the moment. Please try again later'
            }

            this.showConfirmationScreen = true
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>